"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx, jsxs } from "react/jsx-runtime";
import s from "underscore.string";
import React from "react";
import _ from "underscore";
import get from "../data/get";
import Address from "./address";
import ReactUtils from "../../react_utils";
import generalFormatter from "../../formatters/general";
import HoverableValue from "../hoverable_value";
import TmsDeletedWarningIcon from "../load_tms_deleted_warning";
import { cleanReference } from "../../helpers/references";
const bem = ReactUtils.makeBem("load-detail");
function groupByShipment({ stops, shipments }) {
  return shipments.map((shipment) => __spreadProps(__spreadValues({}, shipment), {
    stops: stops.filter((stop) => stop.tms_shipment_ids.indexOf(shipment.id) !== -1).sort(
      (a, b) => new Date(a.updated_at).getTime() - new Date(b.updated_at).getTime()
    )
  }));
}
function isDropType(stop) {
  return stop.type === "TMS::Drop";
}
function calculateDropNumber({ shipments, shipmentIndex, stopIndex }) {
  const previousDropsInPreviousShipments = shipments.slice(0, shipmentIndex).map((shipment) => shipment.stops.filter(isDropType).length).reduce((a, b) => a + b, 0);
  const previousDropsInCurrentShipment = shipments[shipmentIndex].stops.slice(0, stopIndex).filter(isDropType).length;
  return previousDropsInPreviousShipments + previousDropsInCurrentShipment + 1;
}
function formatStopType(stop) {
  return stop.type.substr("TMS::".length).toUpperCase();
}
function formatStopLabel({ stop, number }) {
  if (number !== void 0) {
    return `${formatStopType(stop)} ${number}`;
  } else {
    return formatStopType(stop);
  }
}
function tbodyClasses(index) {
  return bem({ even: index % 2 === 0 });
}
function rowClasses(index) {
  return bem({ "__info-table-data": true, even: index % 2 === 0 });
}
function dropReferences(tmsDrop) {
  return _.map(tmsDrop.references, (v, k) => {
    const value = s.toSentenceSerial(_.flatten([v]));
    return /* @__PURE__ */ jsxs("div", { children: [
      k,
      ": ",
      value
    ] });
  });
}
function maybeShipmentNotesRow(tmsShipment) {
  return tmsShipment.shipment_notes && tmsShipment.shipment_notes.length > 0 && /* @__PURE__ */ jsx("tr", { children: /* @__PURE__ */ jsx("td", { colSpan: 2, className: bem("__shipment_notes_row"), children: /* @__PURE__ */ jsxs("div", { className: bem("__info-reference-pair"), children: [
    /* @__PURE__ */ jsx("span", { className: bem("__info-reference-name"), children: "Shipment Notes:" }),
    tmsShipment.shipment_notes.map((x, i) => /* @__PURE__ */ jsx("p", { children: /* @__PURE__ */ jsx("span", { className: bem("__info-reference-value"), children: x }) }, `shipment-note-${tmsShipment.id}-${i}`))
  ] }) }) });
}
function extraShipmentReferences(tmsShipment) {
  const refs = [];
  _.each(tmsShipment.references, (value, name) => {
    refs.push({
      name,
      value
    });
  });
  return refs;
}
function showValue(props, value) {
  if (props.onValueHighlighted) {
    return /* @__PURE__ */ jsx(
      HoverableValue,
      {
        value,
        onValueHighlighted: props.onValueHighlighted,
        onValueClick: props.onValueClick
      }
    );
  } else {
    return /* @__PURE__ */ jsx("span", { children: value });
  }
}
function viewStopRow(props, { stopIndex, stop, shipment, stopLabel }) {
  let tmsDeletedIcon;
  if (stop.tms_deleted) {
    tmsDeletedIcon = /* @__PURE__ */ jsx(TmsDeletedWarningIcon, {});
  }
  return /* @__PURE__ */ jsxs(
    "tr",
    {
      className: rowClasses(stopIndex + 1),
      children: [
        /* @__PURE__ */ jsxs("td", { className: bem("__align-top"), children: [
          stopLabel,
          " ",
          tmsDeletedIcon
        ] }),
        /* @__PURE__ */ jsxs("td", { className: bem("__align-top"), children: [
          /* @__PURE__ */ jsx(
            Address,
            {
              source: stop,
              onValueHighlighted: props.onValueHighlighted,
              onValueClick: props.onValueClick
            }
          ),
          "Weight: ",
          generalFormatter.weight(stop.weight) || "Unknown",
          dropReferences(stop)
        ] })
      ]
    },
    `drop_info_${shipment.id}_${stop.id}`
  );
}
function shipmentReferences(props, tmsShipment) {
  const references = [
    { name: "Shipment", value: tmsShipment.shipment_id }
  ];
  if (tmsShipment.actual_shipped_at) {
    references.push({
      name: "Pick-up Date",
      value: generalFormatter.dateTime(tmsShipment.actual_shipped_at)
    });
  }
  if (tmsShipment.actual_delivered_at) {
    references.push({
      name: "Drop-off Date",
      value: generalFormatter.dateTime(tmsShipment.actual_delivered_at)
    });
  }
  if (tmsShipment.weight) {
    references.push({
      name: "Weight",
      value: generalFormatter.weight(tmsShipment.weight)
    });
  }
  if (tmsShipment.po) {
    references.push({ name: "PO Number", value: tmsShipment.po });
  }
  if (tmsShipment.pickup_reference) {
    references.push({
      name: "Pickup Reference",
      value: tmsShipment.pickup_reference
    });
  }
  if (tmsShipment.ship_ref) {
    references.push({
      name: "Shipment Reference",
      value: tmsShipment.ship_ref
    });
  }
  if (tmsShipment.shipper && tmsShipment.shipper.name) {
    references.push({
      name: "Shipper Name",
      value: tmsShipment.shipper.name
    });
  }
  if (tmsShipment.customer && tmsShipment.customer.name) {
    references.push({ name: "Customer", value: tmsShipment.customer.name });
  }
  extraShipmentReferences(tmsShipment).forEach((ref) => {
    references.push(ref);
  });
  const html = references.map(cleanReference).map((ref) => {
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: bem("__info-reference-pair"),
        children: [
          /* @__PURE__ */ jsxs("span", { className: bem("__info-reference-name"), children: [
            ref.name,
            ":"
          ] }),
          /* @__PURE__ */ jsx("span", { className: bem("__info-reference-value"), children: showValue(props, ref.value) })
        ]
      },
      `shipment-reference-${ref.name}`
    );
  });
  return /* @__PURE__ */ jsx("div", { children: html });
}
function viewShipment(props, shipment, shipmentIndex, shipments) {
  return /* @__PURE__ */ jsxs(
    "tbody",
    {
      className: tbodyClasses(shipmentIndex),
      children: [
        /* @__PURE__ */ jsxs("tr", { className: bem("__info-table-data"), children: [
          /* @__PURE__ */ jsx("td", { className: bem("__info-with-references"), children: shipmentReferences(props, shipment) }),
          /* @__PURE__ */ jsx("td", { className: bem("__align-top"), children: /* @__PURE__ */ jsx("table", { className: bem("__full-width"), children: /* @__PURE__ */ jsx("tbody", { children: shipment.stops.map((stop, stopIndex) => {
            const number = isDropType(stop) ? calculateDropNumber({
              stopIndex,
              shipmentIndex,
              shipments
            }) : void 0;
            const stopLabel = formatStopLabel({ stop, number });
            return viewStopRow(props, {
              stopIndex,
              stop,
              shipment,
              stopLabel
            });
          }) }) }) })
        ] }),
        maybeShipmentNotesRow(shipment)
      ]
    },
    `drop_info_${shipment.id}`
  );
}
export default React.createClass({
  render: function() {
    const shipments = groupByShipment({
      stops: get.tmsStops(this.props.load),
      shipments: get.tmsShipments(this.props.load)
    });
    if (shipments.length > 0) {
      return /* @__PURE__ */ jsx("div", { className: "row", children: /* @__PURE__ */ jsx("div", { className: "small-10 column", children: /* @__PURE__ */ jsxs(
        "table",
        {
          className: bem("__info-table", "__info-table-with-references"),
          children: [
            /* @__PURE__ */ jsx("thead", { children: /* @__PURE__ */ jsxs("tr", { className: bem("__info-table-header"), children: [
              /* @__PURE__ */ jsx("th", { children: "Shipment" }),
              /* @__PURE__ */ jsx("th", { children: "Stops" })
            ] }) }),
            shipments.map(
              (shipment, shipmentIndex) => viewShipment(this.props, shipment, shipmentIndex, shipments)
            )
          ]
        }
      ) }) });
    }
    return null;
  }
});
